import { IsString } from 'class-validator'

export class AgreementAcceptRequestDto {
  @IsString()
  ip_address: string

  @IsString()
  user_agent: string

}